import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { BannerSlideImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/bannerSlideImpression.trackingInfo";
import { getJsonPayload } from "@omni/utils/dom.utils";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: BannerSlideImpressionTrackingInfo) => {
    const event: AnalyticsEvent<BannerSlideImpressionTrackingInfo> = {
        event: EventType.BannerSlideImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo);
};
